/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AISimplifyLanguage({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#AISimplifyLanguage_svg__a)"><path fill="currentColor" d="M10.454 10.47q-.632 0-.955-.324-.309-.322-.376-.847h-.067a1.78 1.78 0 0 1-.74.982q-.525.35-1.345.35-1.062 0-1.694-.552-.632-.564-.632-1.546 0-1.01.74-1.533.753-.538 2.299-.538h1.331v-.538q0-1.412-1.492-1.412-.673 0-1.09.27-.415.255-.699.685l-.874-.713q.297-.565.995-.968.7-.417 1.802-.417 1.318 0 2.071.632t.753 1.829v3.483h.874v1.156zm-3.066-.915q.712 0 1.17-.323.457-.322.457-.834V7.39H7.711q-1.587 0-1.587.955v.268q0 .471.336.713.337.23.928.229" /><path stroke="currentColor" strokeDasharray="2 3" strokeLinecap="round" strokeWidth={1.2} d="M1.125 15.444h13.75" /></g><defs><clipPath id="AISimplifyLanguage_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;